import type { FormControlLabelProps } from '@material-ui/core/FormControlLabel';
import { Skeleton } from '@material-ui/lab';
import { Translation } from '@ps/web-shared-components';
import { get } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { RadioGroup, useHomeGamesWidget } from '@swf/poker';

import usePutClubOptions from '../hooks/usePutClubOptions';
import { row } from '../shared.scss';

import {
  TXTCLI_Monthly,
  TXTCLI_Quarterly,
  TXTCLI_Yearly,
  TXTWCL_Club_Season_Xfor_standings_X_s_ELL
} from './ClubSeason.messages.json';
import styles from './ClubSeason.scss';

enum SeasonType {
  Yearly = 'HG_CLUB_SEASONS_YEARLY',
  Quarterly = 'HG_CLUB_SEASONS_QUARTERLY',
  Monthly = 'HG_CLUB_SEASONS_MONTHLY'
}

const radioOptions = [
  { value: SeasonType.Yearly, label: <Translation {...TXTCLI_Yearly} /> },
  { value: SeasonType.Quarterly, label: <Translation {...TXTCLI_Quarterly} /> },
  { value: SeasonType.Monthly, label: <Translation {...TXTCLI_Monthly} /> }
];

const ClubSeason: React.FC = () => {
  const { widgetSelect } = useHomeGamesWidget();
  const { clubId } = useParams<{ clubId: string }>();
  const clubOptionsById = useSelector(widgetSelect.clubOptionsById);
  const seasonType = clubOptionsById[clubId]?.seasonType;
  const { loading, onClubOptionsChange } = usePutClubOptions();
  const handleChange: FormControlLabelProps['onChange'] = (event) => {
    onClubOptionsChange({
      clubId: Number(clubId),
      seasonLength: get(event, 'target.value') as SeasonType
    });
  };

  return (
    <div className={row}>
      <Translation tagName="h2" {...TXTWCL_Club_Season_Xfor_standings_X_s_ELL} />
      {seasonType ? (
        <RadioGroup
          disabled={loading}
          name="clubSeasonType"
          options={radioOptions}
          selectedOption={seasonType}
          onChange={handleChange}
        />
      ) : (
        <div className={styles.skeleton}>
          {radioOptions.map(({ value }) => (
            <div key={value}>
              <Skeleton variant="circle" />
              <Skeleton variant="text" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ClubSeason;
